module.exports = {
  draftsList: 'List of Deactivations',
  closedList: 'Closed List',
  editImage: {
    title: 'Edit Image',
  },
  header: {
    title: 'Just In',
    buttonCreate: 'Create',
    buttonPublish: 'Publish',
  },
  table: {
    title: {
      index: 'NO',
      show: 'Active',
      title: 'TITLE',
      link: 'DEEP LINK TYPE',
      partner: 'PARTNER',
      status: 'STATUS',
      action: 'ACTION',
      country: 'COUNTRY',
    },
    tooltip: {
      edit: 'Edit',
      delete: 'Delete',
      inactive: 'InActive',
      active: 'Active',
      schedule: 'Schedule',
    },
    popup: {
      title: 'Confirm',
      okBtn: 'Yes',
      cancelBtn: 'No',
      delete: 'Are you sure to delete this Just In?',
      edit: 'Are you sure to edit this Just In?',
      enable: 'Are you sure you want to enable this Just In?',
      disable: 'Are you sure you want to disable this Just In?',
      confirmPassword: 'Please input your password to confirm.',
    },
  },
  form: {
    image3x4: 'Please upload a 3x4 image',
    imageUpload: '*Upload an image',
    title: 'Title',
    subTitle: 'Subtitle',
    link: 'Link',
    countries: 'Country',
    btnUpdateJustInClubhouse: 'Update',
    btnCreateJustInClubhouse: 'Add',
    scheduleTile: 'Schedule Just In',
    updateJustInClubhouse: 'Edit Just In',
    createJustInClubhouse: 'Add Just In',
    backgroundColor: 'Background Color',
    titleColor: 'Title Color',
    subColor: 'Subtitle Color',
    cta: 'CTA',
    ctaTextColor: 'CTA Text Color',
    ctaBackgroundColor: 'CTA Background Color',
  },
  validate: {
    titleBlank: 'Please input title!',
    countryBlank: 'Please select country!',
    linkBlank: 'Please input a link!',
    imageBlank: 'Please input an image!',
    ctaBlank: 'Please input a CTA!',
    buttonList: 'Please input Button (All Just In) text!',
    buttonDetail: 'Please input Button (Just In Details) text!',
  },
  tab: {
    detail: {
      form: {
        time: {
          title: 'Time',
          startTimePlaceholder: 'Start time',
          endTimePlaceholder: 'End time',
          startDatePlaceholder: 'Start date',
          endDatePlaceholder: 'End date',
        },
        validate: {
          titleBlank: 'Please input title.',
          countryBlank: 'Please select Country',
          descriptionBlank: 'Please input description.',
          startBeforeNow: 'The start date time must be after now.',
          endBeforeNow: 'The end date time must be after now.',
          startBeforeEnd: 'The start date must be before the end date time.',
          startTimeBlank: 'Please input start time.',
          endTimeBlank: 'Please input end time.',
          startDateBlank: 'Please input start date.',
          endDateBlank: 'Please input end date.',
          productNameBlank: 'Please input product name.',
          productDescriptionBlank: 'Please input product description.',
          productVideoTypeBlank: 'Please input product video type.',
          productVideoIdBlank: 'Please input product video id.',
          frequencyBlank: 'Please input push notifications reminder frequency.',
        },
      },
    },
  },
  message: {
    error: {
      uploadImage: 'There was an error while uploading the image. Please try again',
      requireUpload: 'Please upload an image',
    },
    success: {
      updateJustInClubhouse: 'Just In successfully updated.',
      createJustInClubhouse: 'Just In successfully added.',
      deleteJustInClubhouse: 'Just In successfully deleted.',
      scheduleTile: 'The Just In successfully scheduled.',
    },
  },
};
